import _ from "lodash";
import React, { createContext, useCallback, useContext, useState } from "react";

type ZOrderState = {
	setTopWindow: (window: string) => void;
	getWindowOrder: (window: string) => number;
};

const ZOrderContext = createContext<ZOrderState | null>(null);

const ZOrderProvider = ({ children }: React.PropsWithChildren) => {
	const [zOrder, setZorder] = useState<string[]>([]);

	const setTopWindow = useCallback((window: string) => {
		setZorder((prev) => {
			const idx = _.indexOf(prev, window);
			const newOrder = [...prev];
			if (idx > -1) {
				if (idx === prev.length - 1) {
					return prev;
				}
				newOrder.splice(idx, 1);
			}
			newOrder.push(window);
			return newOrder;
		});
	}, []);

	const getWindowOrder = (window: string) => {
		return _.indexOf(zOrder, window);
	};

	return <ZOrderContext.Provider value={{ setTopWindow, getWindowOrder }}>{children}</ZOrderContext.Provider>;
};

const useZOrder = () => {
	const context = useContext(ZOrderContext);

	if (context === null) {
		throw new Error("ZOrderContext is not provided");
	}

	return context;
};

export { useZOrder, ZOrderProvider };
